import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  yearList: [], 
  selectedYearId: null, 
  loading: "idle", 
  error: null,
};

export const financialYearSlice = createSlice({
  name: "financialYear",
  initialState,
  reducers: {
    setFinancialYears: (state, action) => {
      state.yearList = action.payload;
    },
    setSelectedFinancialYear: (state, action) => {
      state.selectedYearId = action.payload;
    },
  },
});


export const { setFinancialYears, setSelectedFinancialYear } = financialYearSlice.actions;

export const selectFinancialYears = (state) => state.financialYear.yearList;
export const selectSelectedYearId = (state) => state.financialYear.selectedYearId;

export default financialYearSlice.reducer;